import { useClaims } from '@auth/useClaims';
import { useRouteParams } from '@vueuse/router';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { useRelatie } from '../../composables/relatie';

export function useTitle(
  isPending: MaybeRefOrGetter<boolean>,
  selectedPakket: MaybeRefOrGetter<string | undefined>,
) {
  const claims = useClaims();

  const polisnummer = useRouteParams('polisnummer', '');

  const getRelatie = useRelatie({
    enabled: () => claims.value.isTemporaryUser === false,
    staleTime: 60_000,
  });

  const titleSubjectText = computed(() => {
    const _selectedPakket = toValue(selectedPakket);

    if (_selectedPakket && getRelatie.data.value?.name) {
      return `Wijzigingen voor pakket ${_selectedPakket} van ${getRelatie.data.value?.name}`;
    }

    if (_selectedPakket) {
      return `Wijzigingen voor pakket ${_selectedPakket}`;
    }

    return `Wijzigingen voor ${getRelatie.data.value?.name ?? polisnummer.value}`;
  });

  const title = computed(() => {
    if (toValue(isPending)) {
      return;
    }

    return [titleSubjectText.value].filter(Boolean).join(' ');
  });

  return {
    title,
  };
}
